



































import { Component, Prop } from 'vue-property-decorator';

import { routes } from '@/router';
import {
  StartGuideCardActiveProgram,
  StartGuideTask
} from '@/models/start-guide';
import { IBusinessType } from '@/models/business';
import flagKeys from '@/constants/flagKeys';
import { Route } from '@/router/route.model';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import BoxProgramStatus from '@/componentsV2/molecules/BoxProgramStatus/BoxProgramStatus.vue';

import RewardsProgramCommon from '../RewardsProgramCommon.vue';
import segmentIo from '@/utils/segment.io';
import { isOnlineProvider } from '@/utils/provider';

@Component({
  components: {
    FilledButton,
    Typography,
    BoxProgramStatus
  }
})
export default class FeedbackStatus extends RewardsProgramCommon {
  @Prop() task!: StartGuideTask;
  @Prop() feature!: string;

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get programStatus() {
    return { operationType: this.rewardOperationType };
  }

  get shouldGoToWidget() {
    return (
      (this.businessInfo.operationType === IBusinessType.BOTH ||
        this.businessInfo.operationType === IBusinessType.ONLINE) &&
      !this.businessInfo.onlineMerchantSignup
    );
  }

  get secondaryButtonText() {
    if (this.featureStore && this.shouldGoToWidget)
      return 'Customize your widget';

    return 'Track program status';
  }

  get isRewardBoth() {
    return this.rewardOperationType === IBusinessType.BOTH;
  }

  get currentProvider() {
    return this.$store.getters['merchant/getCurrentProvider'];
  }

  get rewardOperationType() {
    if (
      this.businessInfo.operationType === IBusinessType.BOTH &&
      !this.flags.includes(flagKeys.addWixMultipleIntegration)
    ) {
      if (!this.currentProvider) return IBusinessType.INSTORE;

      return isOnlineProvider(this.currentProvider.name)
        ? IBusinessType.ONLINE
        : IBusinessType.INSTORE;
    }

    return this.businessInfo.operationType;
  }

  get featureStore() {
    return '';

    // if (this.businessInfo.type === IBusinessType.INSTORE) return false;

    // return this.feature || sessionStorage.getItem(FEATURE_REWARD_STORAGE_KEY);
  }

  get pathToFeatureName() {
    const route: Route = routes.find(
      (item: Route) => item.path === this.featureStore
    );

    if (route) return this.$t(`menus.sidebar.${route.name}`);
    return '';
  }

  get submitText() {
    // TO-DO
    // if (this.featureStore) {
    //   return `Go to ${this.pathToFeatureName}`;
    // }

    if (this.shouldGoToWidget) {
      return 'Customize your widget';
    }

    return 'Explore dashboard';
  }

  get showSecondaryButton() {
    return (
      this.showProgramStatus || (this.featureStore && this.shouldGoToWidget)
    );
  }

  get showProgramStatus() {
    if (!this.loyaltyProgramStatusIsActive) return false;

    if (
      this.rewardOperationType !== IBusinessType.ONLINE &&
      !this.businessInfo.onlineMerchantSignup
    ) {
      return true;
    }

    return this.businessInfo.onlineMerchantSignup && this.isRewardBoth;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get loyaltyProgramStatusIsActive() {
    return this.flags.includes(flagKeys.loyaltyProgramStatus);
  }

  get activePrograms() {
    return this.$store.getters[
      'startGuide/getActivePrograms'
    ] as StartGuideCardActiveProgram[];
  }

  get rewardsProgramStatus() {
    const rewardCoinsProgram = this.activePrograms.find(
      program => program.slug === 'reward-coins'
    );

    if (
      !rewardCoinsProgram ||
      (this.$store.getters['business/getRewardStatus'] &&
        this.$store.getters['business/getRewardStatus'].rewardStatus ===
          'active')
    )
      return 'Active';

    return rewardCoinsProgram.label || 'Active';
  }

  get copies() {
    const mapper: Record<string, any> = {
      [IBusinessType.ONLINE]: {
        Processing: {
          title: `Your Loyalty Program should be up and running within 3 days.`,
          description: `Members will receive Coins after each purchase in the Twism Loyalty Widget on your website.`
        },
        Active: {
          title: `Boom! Everything’s working. Don’t forget to tell people about your new Loyalty Rewards Program.`,
          description: `Members will receive Coins after each purchase in the Twism Loyalty Widget on your website.`
        }
      },
      [IBusinessType.INSTORE]: {
        Processing: {
          title: `Your Loyalty Rewards Program should be up and running within 3 days.`,
          description: `Members with a linked credit card on the Twism mobile app will receive coins after each purchase at your store.`
        },
        Active: {
          title: `Boom! Everything’s working. Don’t forget to tell people about your new Loyalty Rewards Program.`,
          description: `Members with a linked credit card on the Twism mobile app will receive coins after each purchase.`
        }
      },
      [IBusinessType.BOTH]: {
        Processing: {
          title: `You’ve just set up your Online & In-Store Loyalty Rewards Program!`,
          description: `Now your members will earn your Coins for Online purchases or after an in-person payment at your store using the cards linked to their Twism mobile app.`
        },
        Active: {
          title: `You’ve just set up your Online & In-Store Loyalty Rewards Program!`,
          description: `Now your members will earn your Coins for Online purchases or after an in-person payment at your store using the cards linked to their Twism mobile app.`
        }
      }
    };

    if (!mapper[this.rewardOperationType]) {
      return mapper[IBusinessType.ONLINE]['Active'];
    }

    return mapper[this.rewardOperationType][this.rewardsProgramStatus];
  }

  goToProgramStatus() {
    this.$emit('confirm');

    this.$router.push('/program-status');
  }

  clickSecondaryButton() {
    if (this.featureStore && this.shouldGoToWidget) this.goToWidget();
    else if (this.showProgramStatus) this.goToProgramStatus();
  }

  goToWidget() {
    this.$router.push({
      name: 'settings-widget',
      params: { taskSlug: this.task ? this.task.slug : '' }
    });
  }

  onFinish() {
    this.$emit('confirm');

    if (this.featureStore) {
      this.$router.push(this.featureStore);
      return;
    }

    if (this.shouldGoToWidget) {
      this.goToWidget();
    }
  }

  created() {
    segmentIo.modal('Rewards Program Set Up Feedback', {
      'Operation Type': this.rewardOperationType
    });
  }
}
